// Product truth for the marketing site. Every number, name and quote comes from
// the Shopify App Store listing (fetched 2026-10-14) or the product code.
// Do not invent additions: no merchant counts, logos or revenue claims.

export const APP_STORE_URL = "https://apps.shopify.com/pendora-digital-download";
export const APP_STORE_REVIEWS_URL = `${APP_STORE_URL}/reviews`;
export const DEMO_URL = "/orders/test";
export const PRIVACY_URL = "/privacy";
export const DPA_URL = "/dpa";
export const TERMS_URL = "/terms";
export const PUMPER_URL = "https://pumper.run/";

export const RATING = { value: "5.0", count: "1,225", fiveStarShare: "97%" };

export const TRY_URL = "/try";

export const NAV = [
  { href: TRY_URL, label: "Try it" },
  { href: "#how", label: "How it works" },
  { href: "#features", label: "Features" },
  { href: "#brand", label: "Download page" },
  { href: "#reviews", label: "Reviews" },
  { href: "#faq", label: "FAQ" },
];

// Verbatim excerpts from public App Store reviews.
export const REVIEWS = [
  {
    store: "DiaPatisserie",
    country: "United Kingdom",
    quote:
      "Issues get resolved quickly, even outside of standard hours, which makes a real difference when you're running things solo.",
  },
  {
    store: "Templytic.co.za",
    country: "South Africa",
    quote:
      "Great app. Best part is that it's free to use without watermarks. We've used it on multiple stores so far, and it has worked well for me.",
  },
  {
    store: "PT Vitals",
    country: "United States",
    quote:
      "They even helped me test the entire setup and made sure everything was working perfectly before I went live.",
  },
  {
    store: "4YourCNA",
    country: "United States",
    quote:
      "I've been using this app to deliver an ebook and it is awesome to be able to limit downloads and control how the content is accessed.",
  },
  {
    store: "Benji Raconte",
    country: "France",
    quote:
      "We were in search of how to sell digital products as variants with different prices, and this app solves the puzzle positively, despite being free.",
  },
  {
    store: "My Adventure to Fit",
    country: "United States",
    quote:
      "This app was super easy to set up! This fixed our digital downloads instantly which was appreciated.",
  },
  {
    store: "Drew Clarke",
    country: "United States",
    quote:
      "Pendora has been great. Would recommend to anyone selling digital products. They also have great customer service and fast response times.",
  },
  {
    store: "Virellea",
    country: "Denmark",
    quote:
      "I've been using Pandora for their products, e-gifts, and audio guides, and the experience has been great.",
  },
  {
    store: "The Daily Grindhouse",
    country: "United States",
    quote:
      "He did a great job in determining everything was working great and customers will receive my products.",
  },
];

export const FAQ = [
  {
    q: "Is Pendora really free?",
    a: "Yes. Pendora is listed as free on the Shopify App Store, with no paid tiers. Your files and your download page carry no Pendora watermark.",
  },
  {
    q: "What can I sell with it?",
    a: "Any digital file: PDFs, ebooks, audio, video, images, ZIP and RAR archives, software, course material and artwork. You can also sell license keys, on their own or together with a file.",
  },
  {
    q: "How do customers get their files?",
    a: "The moment an order is paid, Pendora fulfils it, shows a download button on Shopify's thank-you page and sends an email with the link. Both open a download page in your colours, in one of 16 languages.",
  },
  {
    q: "Can I limit downloads or let links expire?",
    a: "Yes. Set a maximum number of downloads per order and an expiry in hours, and revoke access to any order at any time. The download page explains the limit to the customer instead of failing silently.",
  },
  {
    q: "Can I sell different files per variant?",
    a: "Yes. Link files or keys to the whole product or to a single variant, so a paperback and a PDF, or a one-year and a lifetime license, can each deliver the right thing.",
  },
  {
    q: "Does it work with my theme?",
    a: "Yes. The download button lives on Shopify's order status page and in the email, not inside your theme code, so there is nothing to install in the theme and nothing to break when you change it.",
  },
  {
    q: "Where are the files hosted?",
    a: "On Amazon S3, served through signed links that expire. The customer's browser downloads straight from the CDN for fast delivery. You can also point a product at a file you host elsewhere.",
  },
];

// Merchant palettes for the download page demo on /. The first one is the
// app's real default (DEFAULT_COLORS in utils/constants.js); the rest are
// illustrative.
export const DEMO_PALETTES = [
  {
    name: "Default",
    bannerBg: "#ffefde",
    bannerText: "#000000",
    border: "#ffd5a8",
    button: "#ff7b02",
    buttonText: "#ffffff",
  },
  {
    name: "Ink",
    bannerBg: "#111318",
    bannerText: "#ffffff",
    border: "#2a2d35",
    button: "#111318",
    buttonText: "#ffffff",
  },
  {
    name: "Moss",
    bannerBg: "#e4efe3",
    bannerText: "#17331c",
    border: "#bfd6bd",
    button: "#2f6b3a",
    buttonText: "#ffffff",
  },
  {
    name: "Plum",
    bannerBg: "#f3e8f8",
    bannerText: "#3b1549",
    border: "#dcc3e8",
    button: "#6d2a8a",
    buttonText: "#ffffff",
  },
  {
    name: "Sea",
    bannerBg: "#e0f1f7",
    bannerText: "#0b3443",
    border: "#b6dbe8",
    button: "#0f6f8f",
    buttonText: "#ffffff",
  },
];

// The download page's languages (utils/language.js), with display names.
export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "es", label: "Español" },
  { code: "de", label: "Deutsch" },
  { code: "it", label: "Italiano" },
  { code: "nl", label: "Nederlands" },
  { code: "sv", label: "Svenska" },
  { code: "da", label: "Dansk" },
  { code: "pl", label: "Polski" },
  { code: "hu", label: "Magyar" },
  { code: "lt", label: "Lietuvių" },
  { code: "bg", label: "Български" },
  { code: "tr", label: "Türkçe" },
  { code: "he", label: "עברית", rtl: true },
  { code: "ja", label: "日本語" },
  { code: "zh", label: "中文" },
];
